var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFF7EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1297 16.3829H18.6557V14.8505H20.1881V13.3244H18.6557V11.792H17.1297V13.3244H15.5973V14.8505H17.1297V16.3829ZM14.0648 19.4541H15.5909V20.9801H14.0648V19.4541ZM12.5324 16.3892H14.0585V17.9153H12.5324V16.3892ZM30.5335 36.2083C33.8714 36.2083 36.6222 33.6966 37 30.4601H24.0671C24.4449 33.6966 27.1957 36.2083 30.5335 36.2083ZM24.0671 28.9341H37C36.6222 25.6977 33.8714 23.1859 30.5335 23.1859C27.1957 23.1859 24.445 25.6977 24.0671 28.9341ZM23.1113 26.6095L17.2509 20.7492L12.9071 25.0931C10.3643 27.6358 10.3643 31.7585 12.9071 34.3012C15.4498 36.844 19.5725 36.844 22.1153 34.3012L23.2717 33.1448C22.7748 32.1 22.4963 30.9311 22.4963 29.6971C22.4963 28.603 22.7153 27.5602 23.1113 26.6095Z",
    fill: "#D76C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5336 21.6597C31.5347 21.6597 32.4929 21.8432 33.3769 22.1777C34.2132 19.8745 33.7082 17.194 31.8612 15.347C29.3184 12.8042 25.1958 12.8042 22.653 15.347L18.3301 19.6699L23.8668 25.2066C25.3108 23.0668 27.7579 21.6597 30.5336 21.6597Z",
    fill: "#D76C0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineicon2);
export default __webpack_public_path__ + "static/media/medicineicon2.73929afb397395aa452545ee24b5bb60.svg";
export { ForwardRef as ReactComponent };